module.exports = __webpack_public_path__ + "img/default-cover.ed7a938b.webp";